module.exports = __webpack_public_path__ + "img/coupon_bg_05.f0c6f052.jpg";